import { z } from 'zod';
import { ChargeablePreauthorization } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { ProcessPaymentFormField } from '../ProcessPaymentFormSchema';
import { gatewayPaymentForSelectedCardSchema } from '../GatewayPaymentForm/schema';

export enum ChargePreauthorizationFormField {
    ReceiptIdentifier = 'receiptIdentifier',
    IsGateway = 'isGateway',
}

const createChargePreauthorizationAmountFormSchema = (
    preauthAmount: ChargeablePreauthorization['amount'] | undefined
) =>
    z.object({
        [ProcessPaymentFormField.Amount]: z
            .number()
            .gt(0)
            .max(preauthAmount?.value ?? 0, TextKey.AmountMustBeLowerThanOriginalAmount),
    });

export const createChargePreauthorizationFormSchema = (
    preauthAmount: ChargeablePreauthorization['amount'] | undefined
) => {
    const chargePreauthorizationBaseFormSchema = gatewayPaymentForSelectedCardSchema.merge(
        createChargePreauthorizationAmountFormSchema(preauthAmount)
    );

    return z.discriminatedUnion(ChargePreauthorizationFormField.IsGateway, [
        chargePreauthorizationBaseFormSchema.extend({ [ChargePreauthorizationFormField.IsGateway]: z.literal(true) }),
        chargePreauthorizationBaseFormSchema.extend({
            [ChargePreauthorizationFormField.IsGateway]: z.literal(false),
            [ChargePreauthorizationFormField.ReceiptIdentifier]: z.string().optional(),
        }),
    ]);
};

export type ChargePreauthorizationFormValues = z.infer<ReturnType<typeof createChargePreauthorizationFormSchema>>;
